module.exports = __webpack_public_path__ + "img/stock1.15d573b6.png";